<template>
    <section class="content">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1>ENTRADA – SALIDA DE STOCK</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                            <li class="breadcrumb-item active">Inventario</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>

        <div class="container-fluid">
            <form @submit.prevent="confirmarEnvio">
                <!-- Paso 1: Datos del movimiento -->
                <div v-if="paso === 1" ref="paso1" class="card">
                    <div class="card-header bg-primary text-white">
                        <h3 class="card-title"><i class="fas fa-edit mr-2"></i>Paso 1: Datos del movimiento</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label>Tipo de operación <i class="fas fa-info-circle text-info" data-toggle="tooltip" title="Seleccione si es una entrada, salida o traslado entre almacenes"></i></label>
                                <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
                                    <label class="btn btn-outline-success flex-fill"
                                        :class="{ active: tipoOperacion === 'entrada' }">
                                        <input type="radio" v-model="tipoOperacion" value="entrada" />
                                        Entrada
                                    </label>
                                    <label class="btn btn-outline-primary flex-fill"
                                        :class="{ active: tipoOperacion === 'traslado' }">
                                        <input type="radio" v-model="tipoOperacion" value="traslado" />
                                        Traslado
                                    </label>
                                    <label class="btn btn-outline-danger flex-fill"
                                        :class="{ active: tipoOperacion === 'salida' }">
                                        <input type="radio" v-model="tipoOperacion" value="salida" />
                                        Salida
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Responsable<i class="fas fa-user text-muted"></i></label>
                                <select v-model="responsable" class="form-control" required>
                                    <option value="" disabled>Selecciona un responsable</option>
                                    <option value="RAFAEL LOPEZ">RAFAEL LOPEZ</option>
                                    <option value="ANTONIO VAIS">ANTONIO VAIS</option>
                                    <option value="ELIAS FREITES">ELIAS FREITES</option>
                                    <option value="OVIDIO LOPEZ">OVIDIO LOPEZ</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Fecha <i class="fas fa-calendar-alt text-muted"></i></label>
                                <input type="date" v-model="fecha" class="form-control" required />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label>Motivo <i class="fas fa-question-circle text-info" data-toggle="tooltip" title="Razón por la cual se realiza el movimiento"></i></label>
                                <select v-model="motivo" class="form-control" required>
                                    <option value="">Selecciona un motivo</option>
                                    <option v-for="m in motivosDisponibles" :key="m.id" :value="m.id">
                                        {{ m.nombre }}
                                    </option>
                                    <option disabled value="vacio" v-if="motivosDisponibles.length === 0">No se encontro motivo</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4" v-if="tipoOperacion !== 'entrada'">
                                <label>Almacén Origen <i class="fas fa-box-open text-warning"></i></label>
                                <select v-model="almacen_origen" class="form-control select2" required>
                                    <option value="" disabled>Selecciona origen</option>
                                    <option v-for="almacen in almacenesOrigenList" :key="almacen.id"
                                        :value="almacen.id">
                                        {{ almacen.descripcion }}
                                    </option>
                                    <option disabled value="vacio" v-if="almacenesOrigenList.length === 0">No se encontro almacen</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4" v-if="tipoOperacion !== 'salida'">
                                <label>Almacén Destino <i class="fas fa-truck-loading text-success"></i></label>
                                <select v-model="almacen_destino" class="form-control select2" required>
                                    <option value="" disabled>Selecciona destino</option>
                                    <option v-for="almacen in almacenesDestinoList" :key="almacen.id"
                                        :value="almacen.id">
                                        {{ almacen.descripcion }}
                                    </option>
                                    <option disabled value="vacio" v-if="almacenesDestinoList.length === 0">No se encontro almacen</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4" v-if="tipoOperacion !== 'traslado'">
                                <label>Documento de Respaldo (PDF/Imagen) <span class="text-danger">*</span></label>
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="documentoMov" ref="fileInput"
                                        accept=".pdf,.jpg,.jpeg,.png" @change="handleFileUpload" 
                                        :required="tipoOperacion !== 'traslado'">
                                    <label class="custom-file-label" for="documentoMov">
                                        {{ archivoRespaldo ? archivoRespaldo.name : 'Seleccionar archivo...' }}
                                    </label>
                                </div>
                                <small class="form-text text-muted">Máximo 4MB. Formatos: PDF, JPG, PNG.</small>
                            </div>
                        </div>
                        <div class="form-row mt-3">
                            <div class="form-group col-md-12">
                                <label>Observaciones Generales <i class="fas fa-comment-dots text-muted"></i></label>
                                <textarea v-model="observaciones" class="form-control" rows="2" 
                                    placeholder="Escriba aquí detalles importantes sobre este movimiento..."></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer d-flex justify-content-between">
                        <button type="button" class="btn btn-secondary" @click="resetPaso1">
                            Limpiar
                        </button>
                        <button type="button" class="btn btn-primary" @click="siguiente">
                            Siguiente
                        </button>
                    </div>
                </div>

                <!-- Paso 2: Selección y edición de productos -->
                <div v-if="paso === 2" ref="paso2" class="card">
                    <div class="card-header bg-primary text-white">
                        <h3 class="card-title"><i class="fas fa-boxes mr-2"></i>Paso 2: Selección de Productos</h3>
                    </div>
                    <div class="card-body">
                        <div class="d-flex mb-2">
                            <button type="button" class="btn btn-sm btn-info" @click="abrirModalProductos">
                                Agregar producto
                            </button>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th>Cantidad</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="prod in productosSeleccionados" :key="prod.id">
                                        <td>{{ prod.codigo }}</td>
                                        <td>{{ prod.descripcion }}</td>
                                        <td>{{ calcularCJyUN(prod) }}</td>
                                        <td>
                                            <button class="btn btn-sm btn-danger" @click="eliminarProducto(prod.id)">
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="productosSeleccionados.length === 0">
                                        <td colspan="4" class="text-center">
                                            No hay productos agregados.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer d-flex justify-content-between">
                        <button type="button" class="btn btn-secondary" @click="anterior">
                            Atrás
                        </button>
                        <button type="button" class="btn btn-primary" @click="siguiente"
                            :disabled="productosSeleccionados.length === 0">
                            Siguiente
                        </button>
                    </div>
                </div>

                <!-- Paso 3: Vista previa y envío -->
                <div v-if="paso === 3" class="card">
                    <div class="card-header bg-primary text-white">
                        <h3 class="card-title"><i class="fas fa-clipboard-check mr-2"></i>Paso 3: Confirmación</h3>
                    </div>
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-sm-3">Almacén Origen:</dt>
                            <dd class="col-sm-9">
                                {{almacenes.find(a => a.id === almacen_origen)?.descripcion}}
                            </dd>
                            <dt class="col-sm-3">Almacén Destino:</dt>
                            <dd class="col-sm-9">
                                {{almacenes.find(a => a.id === almacen_destino)?.descripcion}}
                            </dd>

                            <dt class="col-sm-3">Motivo:</dt>
                            <dd class="col-sm-9">
                                {{motivos.find(m => m.id === motivo)?.nombre}}
                            </dd>

                            <dt class="col-sm-3">Fecha:</dt>
                            <dd class="col-sm-9">{{ fecha }}</dd>

                            <dt class="col-sm-3">Responsable:</dt>
                            <dd class="col-sm-9">
                                {{ responsable }}
                            </dd>

                            <dt class="col-sm-3">Tipo de operación:</dt>
                            <dd class="col-sm-9">{{ tipoOperacion }}</dd>

                            <dt class="col-sm-3">Observaciones:</dt>
                            <dd class="col-sm-9">{{ observaciones || 'Sin observaciones' }}</dd>
                        </dl>
                        <!-- Tabla de productos -->
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th>Cantidad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="p in productosSeleccionados" :key="p.id">
                                        <td>{{ p.codigo }}</td>
                                        <td>{{ p.descripcion }}</td>
                                        <td>{{ calcularCJyUN(p) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer d-flex justify-content-between">
                        <button type="button" class="btn btn-secondary" @click="anterior">
                            Atrás
                        </button>
                        <button type="submit" class="btn btn-success" :disabled="cargando">
                            <span v-if="cargando" class="spinner-border spinner-border-sm mr-1"></span>
                            <i v-else class="fas fa-save mr-1"></i>
                            {{ cargando ? 'Procesando...' : 'Finalizar movimiento' }}
                        </button>
                    </div>
                </div>
            </form>
            <!-- Modal de productos (puede reutilizar tu implementación actual) -->
            <AgregarProductoModal ref="modalAgregarProducto" @producto-seleccionado="agregarProductoDeModal" />
        </div>
    </section>
</template>

<script>
import api from '@/services/api';
import Swal from 'sweetalert2';
import AgregarProductoModal from './AgregarProductoModal.vue';

export default {
    components: {
        AgregarProductoModal
    },
    data() {
        return {
            paso: 1,
            almacenes: [],
            motivos: [],
            productosDisponibles: [],
            productosSeleccionados: [],
            cargando: false,

            // Campos paso 1
            almacen_origen: "",
            almacen_destino: "",
            motivo: "",
            fecha: new Date().toISOString().substr(0, 10),
            responsable: "",
            tipoOperacion: "traslado",
            archivoRespaldo: null,
            observaciones: "",

        }
    },
    computed: {
        motivosDisponibles() {
            // Sólo los motivos cuyo tipo_operacion concuerde con el seleccionado
            return this.motivos.filter(
                m => m.tipo_movimiento === this.tipoOperacion
            )
        },
        almacenesOrigenList() {
            // Todas menos la seleccionada como destino
            return this.almacenes.filter(a => a.id !== this.almacen_destino)
        },
        almacenesDestinoList() {
            // Todas menos la seleccionada como origen
            return this.almacenes.filter(a => a.id !== this.almacen_origen)
        }


    },
    methods: {
        calcularCJyUN(p) {
            const { cantxcaja, cantidad } = p;

            // cajas completas (entero)
            const cajas = Math.floor(cantidad / cantxcaja);

            // unidades sobrantes
            const unidades = cantidad % cantxcaja;

            // variable mutable para concatenar
            let cajasYunidades = '';

            if (cajas > 0) {
                cajasYunidades = `${cajas}CJ`;

                if (unidades > 0) {
                    cajasYunidades += ` + ${unidades}UN`;
                }
            } else {
                // no hay ninguna caja completa
                cajasYunidades = `${unidades}UN`;
            }

            return cajasYunidades;
        },
        siguiente() {
            if (!this.validateCurrentStep()) return
            if (this.paso < 3) this.paso++;
        },
        validateCurrentStep() {
            const container = this.$refs[`paso${this.paso}`]
            if (!container) return true
            let valid = true
            const inputs = container.querySelectorAll('input[required], select[required]')
            inputs.forEach(i => {
                if (!i.checkValidity()) {
                    i.classList.add('is-invalid')
                    valid = false
                } else {
                    i.classList.remove('is-invalid')
                }
            })

            if (this.paso === 1 && this.tipoOperacion !== 'traslado' && !this.archivoRespaldo) {
                const fileInput = container.querySelector('#documentoMov');
                if (fileInput) fileInput.classList.add('is-invalid');
                valid = false;
            }

            return valid
        },
        anterior() {
            if (this.paso > 1) this.paso--;
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (file.size > 4 * 1024 * 1024) {
                Swal.fire('Error', 'El archivo es demasiado grande (máximo 4MB)', 'error');
                event.target.value = '';
                this.archivoRespaldo = null;
                return;
            }
            this.archivoRespaldo = file;
        },
        resetPaso1() {
            this.almacen_destino = "";
            this.almacen_origen = '';
            this.motivo = "";
            this.responsable = "";
            this.fecha = new Date().toISOString().substr(0, 10);
            this.observaciones = "";
            this.archivoRespaldo = null;
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
        abrirModalProductos() {
            this.$refs.modalAgregarProducto.abrirModal();
        },
        agregarProductoDeModal(producto, cant, observacion) {

            this.productosSeleccionados.push({
                ...producto,
                cantidad: cant,
                observacion: observacion
            });
        },
        eliminarProducto(id) {
            this.productosSeleccionados = this.productosSeleccionados.filter(p => p.id !== id);
        },
        async confirmarEnvio() {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: "Se registrará el movimiento de stock permanentemente.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Sí, guardar',
                cancelButtonText: 'Cancelar'
            });
            if (result.isConfirmed) this.guardarMovimiento();
        },
        async guardarMovimiento() {
            this.cargando = true;
            // 0) Precondición: asegúrate de que tipoOperacion sea válido
            const tiposValidos = ['salida', 'entrada', 'traslado'];
            if (!tiposValidos.includes(this.tipoOperacion)) {
                throw new Error(`tipoOperacion inválido: ${this.tipoOperacion}`);
            }

            // 1) Crear FormData
            const formData = new FormData();
            formData.append('fecha', this.fecha);
            formData.append('responsable', this.responsable);
            formData.append('motivo_id', Number(this.motivo));
            formData.append('observ', this.observaciones);
            
            if (this.archivoRespaldo) {
                formData.append('documento', this.archivoRespaldo);
            }

            // 2) Ajustar campos de almacén
            if (this.tipoOperacion === 'salida') {
                formData.append('almacen_id', Number(this.almacen_origen));
            }
            else if (this.tipoOperacion === 'entrada') {
                formData.append('almacen_id', Number(this.almacen_destino));
            }
            else { // traslado
                formData.append('almacen_origen_id', Number(this.almacen_origen));
                formData.append('almacen_destino_id', Number(this.almacen_destino));
            }

            // 3) Mapeo de detalles para Laravel
            this.productosSeleccionados.forEach((p, index) => {
                formData.append(`detalles[${index}][producto_id]`, p.id);
                formData.append(`detalles[${index}][cantidad]`, p.cantidad);
            });

            // 4) Enviar con headers multipart/form-data
            try {
                const url = `/${this.tipoOperacion}s/batch`;
                await api.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'El movimiento ha sido registrado correctamente.',
                    timer: 2000,
                    showConfirmButton: false
                });

                this.resetPaso1();
                this.productosSeleccionados = [];
                this.archivoRespaldo = null;
                this.paso = 1;
            } catch (err) {
                console.error('Error al guardar movimiento:', err);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: err.response?.data?.message || err.response?.data?.error || 'No se pudo procesar el movimiento.'
                });
            } finally {
                this.cargando = false;
            }
        },
    },
    watch: {
        tipoOperacion() {
            this.resetPaso1()
        },
    },
    async mounted() {
        const [a, p, m] = await Promise.all([
            api.get('/almacen'),
            api.get('/producto'),
            api.get('/motivos')
        ]);
        this.almacenes = a.data.filter(almacen => almacen.estatus !== 0);
        this.productosDisponibles = p.data;
        this.motivos = m.data;
    }
};
</script>
